// Wraps fetch with automatic retry on transient network failures.
// "Failed to fetch" / 502 / 503 / 504 happen frequently on showroom WiFi
// and at Cloudflare edge during slow 25-30s image-generation calls.
// We retry up to 2 times with a short backoff. POST is repeatable here
// because the endpoints are idempotent-by-content for the user.
// When a retry succeeds, we dispatch a global "hedaply:retry-success"
// CustomEvent so the UI can show a small reassurance toast.
export async function resilientFetch(
  url,
  options = {},
  { retries = 2, backoffMs = 800 } = {}
) {
  let lastErr;
  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      const res = await fetch(url, options);
      if ([502, 503, 504].includes(res.status) && attempt < retries) {
        await new Promise((r) => setTimeout(r, backoffMs * (attempt + 1)));
        continue;
      }
      // Successful response after one or more retries → tell the UI.
      if (attempt > 0 && res.ok && typeof window !== "undefined") {
        try {
          window.dispatchEvent(new CustomEvent("hedaply:retry-success"));
        } catch {
          // no-op — older browsers without CustomEvent
        }
      }
      return res;
    } catch (err) {
      lastErr = err;
      if (attempt < retries) {
        await new Promise((r) => setTimeout(r, backoffMs * (attempt + 1)));
        continue;
      }
      throw err;
    }
  }
  throw lastErr || new Error("Network error");
}
